import { TReduxActions } from '../../types/redux';
import { EBuildersInfoActionTypes } from '../../actions/buildersInfo';

export const loadingReducer = (state: boolean = false, action: TReduxActions) => {
  switch (action.type) {
    case EBuildersInfoActionTypes.Request:
      return true;
    case EBuildersInfoActionTypes.Failure:
    case EBuildersInfoActionTypes.Success:
      return false;

    default:
      return state;
  }
};
